import React from 'react'
import style from './Checkbox.module.scss'

const Checkbox = () => <div className={style.checkbox}></div>

export default Checkbox
